const TRUE_STRING = (true).toString();
const FALSE_STRING = (false).toString();
export const _caseInsensitiveTrueString = TRUE_STRING.toLowerCase();
export const _caseInsensitiveFalseString = FALSE_STRING.toLowerCase();
export const trueString = TRUE_STRING;
export const falseString = FALSE_STRING;
